module.exports = __webpack_public_path__ + "img/pedestal-bulibuli.9a35ee73.png";